export const FIRST_NAME = {
  name: "firstname",
  placeholder: "Peggy",
  label: "First Name",
};

export const LAST_NAME = {
  name: "lastname",
  placeholder: "Olsen",
  label: "Last Name",
};

export const COMPANY_NAME = {
  name: "businessName",
  placeholder: "Company name",
  label: "Business Name (optional)",
};

export const COUNTRY_ID = {
  name: "countryId",
  type: "country",
};

export const PHONE = {
  name: "phone",
  placeholder: "(555) 555-5555",
  label: "Phone Number",
};

export const FORMATTED_ADDRESS = {
  name: "formattedAddress",
  placeholder: "13 East 27th Street",
  label: "Address",
};

export const SUGGESTIONS_DROPDOWN = {
  name: "suggestionsDropdown",
};

export const ADDRESS1 = {
  name: "address1",
};

export const ADDRESS2 = {
  name: "address2",
  placeholder: "Apt 000",
  label: "Suite/APT/Other",
};

export const CITY = {
  name: "city",
  placeholder: "New York",
  label: "City",
  type: "city",
};

export const STATE_NAME_NON_US = {
  name: "stateNameNonUs",
  placeholder: "NY",
  label: "",
  type: "state",
};

export const STATE_NAME = {
  name: "stateName",
  placeholder: "Search",
  label: "State/County/Province",
  type: "state",
};

export const ZIPCODE_NON_US = {
  name: "zipcodeNonUs",
  placeholder: "00000",
  label: "Zip Code/PIN",
};

export const ZIPCODE = {
  name: "zipcode",
  placeholder: "00000",
  label: "Zip Code/PIN",
};

export const PROFILE_SETUP_FORM_FIELDS = [
  FORMATTED_ADDRESS,
  ADDRESS2,
  CITY,
  STATE_NAME,
  ZIPCODE,
  COUNTRY_ID,
  PHONE,
];

export const NEW_DEFAULT_FORM_FIELDS = [
  FIRST_NAME,
  LAST_NAME,
  COMPANY_NAME,
  COUNTRY_ID,
  PHONE,
  FORMATTED_ADDRESS,
  ADDRESS2,
  CITY,
  STATE_NAME,
  ZIPCODE,
];
